import ReactDiffViewer from 'react-diff-viewer-continued';
import styled from 'styled-components';
import { BUTTON_SIZES, Button } from 'ui/button';
import { MODAL_SIZES, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { fontSizes, spacing } from 'ui/theme';
import { useModalContext } from 'utils/contexts/modal';

import { useWYSIWYGContext } from '../../contexts/WYSIWYGContext';
import { useHandleHtmlCleanup } from '../../hooks';
import { useTranslations } from '../../hooks/useTranslations';
import { repairHTMLBody, repairHTMLFullDoc } from '../../utils';

const StyledModalBody = styled(ModalBody)`
  flex: 1 1 auto;
  padding: 0 ${spacing.plusHalf} ${spacing.plusHalf};
`;

const StyledModalSubheader = styled(ModalBody)`
  border: none;
  flex: 0 0 auto;
  font-size: ${fontSizes.s14};
  padding: 0 ${spacing.plusHalf} ${spacing.plusHalf};
`;

export const HtmlCleanupConfirmationModal = () => {
  const { t } = useTranslations();
  const { hideModal } = useModalContext();
  const { isFullHtmlDoc, lastSavedValue } = useWYSIWYGContext();
  const handleHtmlCleanup = useHandleHtmlCleanup();

  const newCode = isFullHtmlDoc
    ? repairHTMLFullDoc(lastSavedValue)
    : repairHTMLBody(lastSavedValue);
  const oldCode = lastSavedValue;

  return (
    <Modal
      id="wysiwygHtmlCleanupConfirmationModal"
      isModalOpen={true}
      onClose={hideModal}
      size={MODAL_SIZES.LARGE}
    >
      <ModalHeader autoFocus={false}>{t('header.cleanUpTool')}</ModalHeader>
      <StyledModalSubheader>{t('caption.cleanUpToolSubheader')}</StyledModalSubheader>
      <StyledModalBody>
        <ReactDiffViewer
          leftTitle={t('label.oldCode')}
          newValue={newCode}
          oldValue={oldCode}
          rightTitle={t('label.newCodeClean')}
          splitView={true}
          styles={{
            contentText: { wordWrap: `unset` }, // break long lines as necessary
            // @ts-ignore
            lineNumber: { whiteSpace: `nowrap !important` }, // prevent line numbers from wrapping
          }}
          useDarkTheme={true}
        />
      </StyledModalBody>

      <ModalFooter>
        <Button
          onClick={() => {
            handleHtmlCleanup();
            hideModal();
          }}
          size={BUTTON_SIZES.LARGE}
          type="submit"
        >
          {t('button.applyChanges')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
